import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class VRService {

    vrViewDisplayed: BehaviorSubject<any> = new BehaviorSubject(null);

    constructor(){}

    public getVRView(): Observable<any>{
        return this.vrViewDisplayed.asObservable();
    }
    public setVRView(viewId: string): void {
        this.vrViewDisplayed.next(viewId);
    }

}